<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '../stores/app';
import { navItems, personalInfo } from '../data/portfolio';

const appStore = useAppStore();

const displayName = computed(() => 
  appStore.isZh ? personalInfo.name : personalInfo.nameEn
);

function handleNavClick(href: string) {
  const sectionId = href.replace('#', '');
  appStore.scrollToSection(sectionId);
}

function toggleLanguage() {
  appStore.setLanguage(appStore.isZh ? 'en' : 'zh');
}
</script>

<template>
  <nav class="nz-navbar" :class="{ scrolled: appStore.isScrolled }">
    <div class="nav-fire-line"></div>
    
    <div class="nav-container">
      <a href="#home" class="nav-logo" @click.prevent="handleNavClick('#home')">
        <div class="logo-fire">
          <i class="fas fa-fire"></i>
          <div class="fire-glow"></div>
        </div>
        <span class="logo-text">{{ displayName }}</span>
      </a>

      <div class="nav-links">
        <a
          v-for="item in navItems"
          :key="item.id"
          :href="item.href"
          class="nav-link"
          :class="{ active: appStore.activeSection === item.id }"
          @click.prevent="handleNavClick(item.href)"
        >
          <i :class="['fas', item.icon]"></i>
          <span class="link-text">{{ appStore.isZh ? item.label : item.labelEn }}</span>
          <span class="link-indicator"></span>
        </a>
      </div>

      <div class="nav-actions">
        <button class="lang-toggle" @click="toggleLanguage">
          <i class="fas fa-language"></i>
          <span>{{ appStore.isZh ? 'EN' : '中' }}</span>
        </button>

        <button class="menu-toggle" @click="appStore.toggleMenu">
          <span class="menu-bar" :class="{ open: appStore.isMenuOpen }"></span>
        </button>
      </div>
    </div>

    <transition name="mobile-menu">
      <div v-if="appStore.isMenuOpen" class="mobile-menu">
        <a
          v-for="item in navItems"
          :key="item.id"
          :href="item.href"
          class="mobile-link"
          :class="{ active: appStore.activeSection === item.id }"
          @click.prevent="handleNavClick(item.href)"
        >
          <i :class="['fas', item.icon]"></i>
          <span>{{ appStore.isZh ? item.label : item.labelEn }}</span>
        </a>
      </div>
    </transition>
  </nav>
</template>

<style scoped>
@import '../styles/components/navbar.css';
</style>
